import React from 'react';
import ReportLanding from '../components/Report/Report';

function ReportPage() {
  return <ReportLanding />;
}
export default ReportPage;
